import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';

export interface BridgePerformanceProps {}

export const BridgePerformance = ({}: BridgePerformanceProps) => {
    return (
        <>
            <SectionHeaderBar title={'Performance'}></SectionHeaderBar>
        </>
    );
};
